var exports = {
  "Mv": "TextareaButtons.module__invisibleTrigger___VGRCVD",
  "IO": "TextareaButtons.module__mobileRightButtonContainer___VGRCVD",
  "Pc": "TextareaButtons.module__mobileRightButtonSlot___VGRCVD",
};

module.exports = exports;
